import React, { useCallback } from 'react'
import { GenericSearch } from 'app/views/components/search/generic-search'
import { EntitySearchItem, EntitySearchTable } from 'app/views/components/search/entity-search-table'
import { useNavigate } from 'react-router-dom'

interface Props {
  data: EntitySearchItem[]
  placeholder?: string
  width?: number
  dropdownWidth?: number
  transformX?: number
}

export function EntitySearch({
  data,
  placeholder = 'Entity Search',
  width = 300,
  dropdownWidth = 570,
  transformX = 166,
}: Props) {
  const navigate = useNavigate()

  const navigateToEntity = useCallback(
    (entityId: string, status: string) => {
      if (entityId) {
        navigate(`/entitymanagement/entity/${entityId}/${status}`)
      }
    },
    [navigate],
  )

  const handleEntitySelect = useCallback(
    (entity: EntitySearchItem) => {
      const entityStatus = entity.status || 'Active'
      const normalizedStatus =
        entityStatus.charAt(0).toUpperCase() +
        entityStatus.slice(1).toLowerCase()
      navigateToEntity(entity.id || '', normalizedStatus)
    },
    [navigateToEntity],
  )

  const renderEntityTable = useCallback(
    (
      filteredData: EntitySearchItem[],
      searchValue: string,
      onItemSelect: (entity: EntitySearchItem) => void,
      onClose: () => void,
    ) => {
      return (
        <EntitySearchTable
          data={filteredData}
          searchValue={searchValue}
          onEntitySelect={onItemSelect}
          onClose={onClose}
        />
      )
    },
    [],
  )

  return (
    <GenericSearch
      data={data}
      placeholder={placeholder}
      searchableFields={['entityName', 'mei', 'internalId', 'systemId']}
      onItemSelect={handleEntitySelect}
      renderTable={renderEntityTable}
      width={width}
      dropdownWidth={dropdownWidth}
      className="generic-search"
      transformX={transformX}
      storageKey="entity-search-value"
    />
  )
}
